import React from 'react'
import { Flex, Heading, Link } from '@chakra-ui/react'
import { Switch, Route, Link as RouterLink, Redirect } from 'react-router-dom'
import { AuthContextProvider, AuthContext } from './context/auth/index.js'
import { ROUTES } from './contants'
import {
  MotorIndex,
  Signup,
  Login,
  Insurance,
  Quotes,
  QuoteDetails,
  Policy,
  PolicyDetails,
  GadgetIndex,
  Dashboard,
  Notifications,
  Settings,
  Profile,
  Security,
  Claims,
  Faqs,
  Privacy,
  Terms,
  ResetIndex,
  Verify
} from './pages'
import { Error400 } from './pages/errors/400'
import { Error403 } from './pages/errors/403'
import { Error404 } from './pages/errors/404'
import { Error500 } from './pages/errors/500'

export default function App() {
  // const [setNotifications, setNewMessage] = useNotificationStore((state) => [
  //   state.setNotifications,
  //   state.setNewMessage
  // ])
  // onMessageListener()
  //   .then((payload: any) => {
  //     setNotifications(payload.notification)
  //     setNewMessage(true)
  //     console.log('payload', payload)
  //   })
  //   .catch((err) => console.log('failed: ', err))

  return (
    <AuthContextProvider>
      <Switch>
        <Route exact path="/400" component={Error400} />
        <Route exact path="/500" component={Error500} />
        <Route exact path="/403" component={Error403} />
        <Route exact path="/404" component={Error404} />

        <PublicRoute exact path={ROUTES.signup} component={Signup} />
        <PublicRoute exact path={ROUTES.resetPassword} component={ResetIndex} />
        <PublicRoute exact path={ROUTES.login} component={Login} />
        <PublicRoute exact path={ROUTES.verify} component={Verify} />
        <Route exact path={ROUTES.insurance} component={Insurance} />
        <PrivateRoute exact path={ROUTES.dashboard} component={Dashboard} />
        <PrivateRoute exact path={ROUTES.notifications} component={Notifications} />
        <Route exact path={ROUTES.buyGadget.base} component={GadgetIndex} />
        <PrivateRoute exact path={ROUTES.quotes.base} component={Quotes} />
        <PrivateRoute exact path={ROUTES.quotes.details} component={QuoteDetails} />
        <PrivateRoute exact path={ROUTES.policies.base} component={Policy} />
        <PrivateRoute exact path={ROUTES.policies.details} component={PolicyDetails} />
        <Route exact path={ROUTES.buyMotor.base} component={MotorIndex} />
        <PrivateRoute exact path={ROUTES.settings.base} component={Settings} />
        <PrivateRoute exact path={ROUTES.settings.profile} component={Profile} />
        <PrivateRoute exact path={ROUTES.settings.security} component={Security} />
        <PrivateRoute exact path={ROUTES.settings.claims} component={Claims} />
        <PrivateRoute exact path={ROUTES.settings.faqs} component={Faqs} />
        <Route exact path={ROUTES.settings.privacyPolicy} component={Privacy} />
        <Route exact path={ROUTES.settings.tAndC} component={Terms} />
        <PublicRoute exact path={ROUTES.base} component={Signup} />

        <Route component={NotFound} />
      </Switch>
    </AuthContextProvider>
  )
}

const NotFound = () => (
  <Flex flexDirection="column" minH="100vh" justify="center" align="center">
    <Heading>404 - Not Found!</Heading>
    <Link as={RouterLink} to="/">
      Go Home
    </Link>
  </Flex>
)

function PublicHome({ path, exact, component }: { [x: string]: any }) {
  const { authState } = React.useContext(AuthContext)

  const isLoggedIn = authState?.token

  return (
    <>
      {!isLoggedIn ? (
        <Route path={path} exact={exact} component={component} />
      ) : (
        <Redirect to="/dashboard" />
      )}
    </>
  )
}

function PrivateRoute({ path, exact, component }: { [x: string]: any }) {
  const { authState } = React.useContext(AuthContext)

  const isLoggedIn = authState?.token

  return (
    <>
      {isLoggedIn ? <Route path={path} exact={exact} component={component} /> : <Redirect to="/" />}
    </>
  )
}

function PublicRoute({ path, exact, component }: { [x: string]: any }) {
  const { authState } = React.useContext(AuthContext)

  const isLoggedIn = authState?.token

  return (
    <>
      {!isLoggedIn ? (
        <Route path={path} exact={exact} component={component} />
      ) : (
        <Redirect to="/dashboard" />
      )}
    </>
  )
}
